//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// dto_for_DV1_UpdateAssetsForTag_Request
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class dto_for_DV1_UpdateAssetsForTag_Request {

    tag_id = null
    practice_ids_add = []
    practice_ids_remove = []

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){
    //};
}